<div class="box-notifications">
  <!-- Mobile Backdrop Overlay (click to close) -->
  <div 
    class="notification-backdrop" 
    *ngIf="isDropdownOpen"
    (click)="toggleDropdown()"
    aria-hidden="true"
  ></div>

  <!-- Notification Bell Button -->
  <button 
    class="e-round btn-notification" 
    (click)="toggleDropdown()"
    [class.active]="isDropdownOpen"
    aria-label="Notifications"
  >
    <i class="fa-regular fa-bell" style="color: #9e1c20"></i>
    <div class="new-chat-count" *ngIf="unreadCount > 0" style="color: #fff">
      {{ unreadCount > 99 ? '99+' : unreadCount }}
    </div>
  </button>

  <!-- Notification Dropdown Panel -->
  <div class="notification-dropdown" *ngIf="isDropdownOpen">
    <!-- Loading State -->
    <div class="notification-loading" *ngIf="isLoading">
      <div class="spinner"></div>
      <p>{{ ('NOTIFICATION.LOADING' | translate) || 'Loading notifications...' }}</p>
    </div>

    <!-- Empty State -->
    <div class="notification-empty" *ngIf="!isLoading && notifications.length === 0">
      <i class="fa-regular fa-bell-slash"></i>
      <p>{{ ('NOTIFICATION.NO_NOTIFICATIONS' | translate) || 'No notifications yet' }}</p>
      <span>{{ ('NOTIFICATION.ALL_CAUGHT_UP' | translate) || "You're all caught up!" }}</span>
    </div>

    <!-- Notification List -->
    <div class="notification-list" *ngIf="!isLoading && notifications.length > 0">
      <div 
        class="notification-item" 
        *ngFor="let notification of notifications"
        [class.unread]="!notification.isRead"
        (click)="onNotificationClick(notification)"
      >
        <!-- Unread Indicator -->
        <!-- <div class="unread-indicator" *ngIf="!notification.isRead"></div> -->

        <!-- Notification Content -->
        <div class="notification-content">
          <!-- Icon based on type/menuId -->
          <div class="notification-icon">
            <i class="fa-solid fa-circle-info" *ngIf="!notification.menuId || notification.menuId === 1"></i>
            <i class="fa-solid fa-file-contract" *ngIf="notification.menuId === 5"></i>
            <i class="fa-solid fa-hand-holding-dollar" *ngIf="notification.menuId === 3"></i>
            <i class="fa-solid fa-bell" *ngIf="notification.menuId && notification.menuId !== 1 && notification.menuId !== 5 && notification.menuId !== 3"></i>
          </div>

          <!-- Message & Metadata -->
          <div class="notification-body">
            <p class="notification-message">{{ notification.alertMsg }}</p>
            
            <!-- Additional Info -->
            <div class="notification-meta">
              <span class="notification-time">
                <i class="fa-regular fa-clock"></i>
                {{ getTimeAgo(notification.alertTime) }}
              </span>
              <span class="notification-policy" *ngIf="notification.policyNo">
                <i class="fa-solid fa-file"></i>
                {{ notification.policyNo }}
              </span>
            </div>
          </div>

          <!-- Mark as Read Button -->
          <button 
            class="btn-mark-read"
            *ngIf="!notification.isRead"
            (click)="markAsRead(notification, $event)"
            aria-label="Mark as read"
            title="Mark as read"
          >
            <i class="fa-solid fa-check"></i>
          </button>
        </div>
      </div>

      <!-- Footer with Actions and Info -->
      <div class="notification-footer">
        <div class="footer-actions">
          <button 
            class="btn-footer-action" 
            (click)="refreshNotifications()"
            [disabled]="isLoading"
            aria-label="Refresh notifications"
            title="Refresh"
          >
            <i class="fa-solid fa-rotate-right" [class.spinning]="isLoading"></i>
          </button>
          
          <button 
            class="btn-footer-action" 
            (click)="markAllAsRead($event)"
            [disabled]="unreadCount === 0"
            title="Mark all as read"
          >
            <i class="fa-solid fa-check-double"></i>
          </button>

          <button 
            class="btn-footer-action btn-load-more" 
            (click)="loadMoreNotifications()"
            [disabled]="isLoadingMore || !pagination.hasMore"
            *ngIf="pagination.hasMore"
            title="Load more"
          >
            <i class="fa-solid fa-chevron-down" *ngIf="!isLoadingMore"></i>
            <i class="fa-solid fa-spinner fa-spin" *ngIf="isLoadingMore"></i>
          </button>
        </div>

        <span class="notification-count">
          <i class="fa-solid fa-list"></i>
          {{ notifications.length }} / {{ pagination.totalCount }}
        </span>
      </div>
    </div>
  </div>
</div>